import React, { useState } from 'react';
import { useRecordContext, useInput } from 'react-admin';
import { HexColorPicker } from 'react-colorful';
import { Box, Popover, Button } from '@mui/material';

// ColorField component for displaying colors in List views
export const ColorField = ({ source, showText = true, ...props }) => {
    const record = useRecordContext();
    if (!record || !record[source]) return null;

    const color = record[source];

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Box
                sx={{
                    width: '20px',
                    height: '20px',
                    minWidth: '20px',
                    minHeight: '20px',
                    maxWidth: '20px',
                    maxHeight: '20px',
                    backgroundColor: color,
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxSizing: 'border-box',
                }}
            />
            {showText && <span>{color}</span>}
        </Box>
    );
};

// ColorInput component for Edit/Create forms
export const ColorInput = ({ source, label, ...props }) => {
    const {
        field,
        fieldState: { error },
    } = useInput({ source, ...props });

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const color = field.value || '#000000';

    return (
        <Box sx={{ margin: '8px 0' }}>
            {label && (
                <label
                    style={{
                        display: 'block',
                        fontSize: '0.75rem',
                        color: 'rgba(0, 0, 0, 0.6)',
                        marginBottom: '4px',
                    }}
                >
                    {label}
                </label>
            )}
            <Button
                onClick={handleClick}
                variant="outlined"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    textTransform: 'none',
                    justifyContent: 'flex-start',
                    minWidth: '200px',
                }}
            >
                <Box
                    sx={{
                        width: 24,
                        height: 24,
                        backgroundColor: color,
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                    }}
                />
                <span>{color}</span>
            </Button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ padding: 2 }}>
                    <HexColorPicker
                        color={color}
                        onChange={field.onChange}
                    />
                    <Box sx={{ marginTop: 1, textAlign: 'center' }}>
                        <Button onClick={handleClose} size="small">
                            Close
                        </Button>
                    </Box>
                </Box>
            </Popover>
            {error && (
                <span style={{ color: 'red', fontSize: '0.75rem' }}>
                    {error.message}
                </span>
            )}
        </Box>
    );
};
